import {
  Box,
  Paper,
  Title,
  createStyles,
  Loader,
  Select,
  Group,
  Text,
  TextInput,
  Button,
  MultiSelect,
  Accordion,
  Grid,
} from "@mantine/core";

import { Summary } from "./SummaryAi";
import heartSvg from "../../assets/img/heart.svg";
import aiSvg from "../../assets/img/ai.svg";
import losSvg from "../../assets/img/los.svg";
import hospitalSvg from "../../assets/img/hospitalAI.svg";
import symptomsSvg from "../../assets/img/symptoms-check-icon.svg";
import aiStartsSvg from "../../assets/img/mdi_stars.svg";

// import svg from ".././../assets/img/Dexcom.svg"
import others from "../../assets/img/others.svg";
import EpicSelect from "../../assets/img/EpicPatint.svg";
import cernerSelecr from "../../assets/img/CernerPatient.svg";
import aaathenaSelect from "../../assets/img/AthenaPatient.svg";

import { forwardRef, useEffect, useState } from "react";
import { useMedplum } from "@medplum/react";
import { getPatientName } from "../Eligibility/EligibiltyService";
import { showNotification } from "@mantine/notifications";
import {
  extractNoteTexts,
  formatAiSummary,
  formatCardioSummary,
  formatDataForSubheading,
  formatLosPrediction,
  formatReadmissionPrediction,
  getLOSPrediction,
  getMedicationResource,
  getReadmissionPrediction,
  getSymptoms,
  summarizeDisease,
} from "./aiService";
import { COLORS } from "./costansts";
import { IconPlus } from "@tabler/icons-react";
import Card from "./Card";

interface ItemProps extends React.ComponentPropsWithoutRef<"div"> {
  label: string;
  value: any;
  ehr: string;
  icon: any;
}

const useStyles = createStyles(() => ({
  default: {
    borderRadius: "8px",
    marginLeft: "40px",
    marginRight: "40px",
    height: "100%",
    padding: "16px",
    marginTop: "16px",
  },
  createVideoAppointment: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  heading: {
    fontWeight: 700,
    fontSize: "26px",
    lineHeight: "36px",
    color: "#262930",
  },
  select: {
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "21px",
    color: "#262930",
  },
  tite: {
    fontWeight: 600,
    fontSize: "21px",
    lineHeight: "28px",
    marginBottom: "16px",
  },
  subHeading: {
    tite: {
      fontWeight: 600,
      fontSize: "22px",
      lineHeight: "30px",
      marginBottom: "16px",
      color: "",
    },
  },
  "filter-blue": {
    filter:
      "invert(35%) sepia(96%) saturate(778%) hue-rotate(175deg) brightness(88%) contrast(91%)",
  },
  ai: {
    minWidth: "104px",
    height: "74px,",
    padding: "8px",
    borderRadius: "8px",
    gap: "8px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },
  imageStyle: {
    width: "24px",
    height: "24px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  boxFirst: {
    display: "flex",
    flexDirection: "column",
    border: "1px solid #EDEDED",
    borderRadius: "10px",
    minHeight: "349px",
    width: "100%",
    padding: "16px",
    gap: "32px",
  },
}));

export const Recipes = () => {
  const initSummaryTags = {
    diseases: [] as string[],
    drugs: [] as string[],
    observations: [] as string[],
  };

  const { classes } = useStyles();
  const medplum = useMedplum();
  const [showAi, setShowAi] = useState<number | null>(null);
  const [patientList, setPatientList] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedPatient, setSelectedPatient] = useState<any>(null);
  const [showSumm, setShowSumm] = useState<boolean>(true);
  const [aiResponse, setAiResponse] = useState<string>(
    "Please Select an AI Recipe..."
  );
  const [cardioRed, setCardioRed] = useState<boolean | boolean>(false);
  const [summaryTags, setSummaryTags] = useState(initSummaryTags);
  const [cardioPrediction, setCardioPrediction] = useState<
    string | undefined
  >();
  const [selectedSymptom, setSelectedSymptoms] = useState<string | undefined>();
  const [patientName, setPatientName] = useState<any>();
  const [input, setInput] = useState<any>([]);

  const [data, setData] = useState([
    { value: "cough", label: "Cough" },
    { value: "cold", label: "Cold" },
  ]);

  const recipeList = [
    {
      label: "Summary",
      value: 1,
      icon: aiSvg,
    },
    {
      label: "Cardiovascular",
      value: 2,
      icon: heartSvg,
    },
    {
      label: "Length of Stay",
      value: 3,
      icon: losSvg,
    },
    {
      label: "Readmission",
      value: 4,
      icon: hospitalSvg,
    },
    {
      label: "Symptom",
      value: 5,
      icon: symptomsSvg,
    },
  ];

  useEffect(() => {
    getPatientList();
  }, []);

  useEffect(() => {
    if (selectedPatient) {
      getSummaries();
    }
  }, [selectedPatient, showAi]);
  useEffect(() => {
    if (selectedPatient && showAi === 5) {
      getSymptomsForPatient();
    }
  }, [selectedPatient, showAi === 5]);

  const getSummaries = async () => {
    setInput([]);
    setShowSumm(true);
    let summaryDetails = null;
    if (showAi == 1) {
      summaryDetails = await formatAiSummary(
        medplum,
        selectedPatient,
        setAiResponse,
        setCardioPrediction,
        setSummaryTags,
        setCardioRed
      );
      setInput(summaryDetails?.input?.[0]?.[0]);
    }
    if (showAi == 2) {
      summaryDetails = await formatCardioSummary(
        medplum,
        selectedPatient,
        setAiResponse,
        setCardioPrediction,
        setSummaryTags,
        setCardioRed
      );
      setInput(summaryDetails?.input?.[0]);
    }
    if (showAi == 3) {
      summaryDetails = await formatLosPrediction(
        medplum,
        selectedPatient,
        setAiResponse,
        setCardioPrediction,
        setSummaryTags,
        setCardioRed
      );

      // const subHeading = formatDataForSubheading(summaryDetails?.input);

      setInput(summaryDetails?.input);
    }
    if (showAi == 4) {
      summaryDetails = await formatReadmissionPrediction(
        medplum,
        selectedPatient,
        setAiResponse,
        setCardioPrediction,
        setSummaryTags,
        setCardioRed
      );

      setInput(summaryDetails?.input);
    }
  };

  const getSymptomsForPatient = async () => {
    const response = await getMedicationResource(medplum, selectedPatient);
    const symptoms = extractNoteTexts(response);
    setSelectedSymptoms(symptoms);
  };

  const showaiSummary = (val: number) => {
    if (aiResponse === "Generating...") return;
    setShowAi(val);
    if (val === 5) {
      setAiResponse("Please enter symptoms");
      setCardioPrediction("");
      setCardioRed(false);
      setCardioPrediction(undefined);
    }
    // if (selectedPatient) genSummary();
  };

  const getPatientList = async () => {
    setIsLoading(true);
    const res = await medplum.searchResources("Patient", "_count=500");
    const patientData = res.map((patient) => {
      const containsCerner = patient?.identifier?.[0]?.type?.coding?.some(
        (coding) => coding.system?.includes("cerner")
      );
      const containsAthena = patient?.identifier?.some(
        (item) => item.system && item.system.includes("athena")
      );
      let ehrtype = "";
      if (
        patient?.identifier?.find(
          (id) => id.system === "urn:oid:1.2.840.114350.1.13.0.1.7.5.737384.0"
        )
      ) {
        ehrtype = "EPIC";
      } else if (containsCerner) {
        ehrtype = "Cerner";
      } else if (containsAthena) {
        ehrtype = "Athena Health";
      } else {
        ehrtype = "Others";
      }
      let EHRIcon;
      switch (ehrtype) {
        case "EPIC":
          EHRIcon = (
            <img
              src={EpicSelect}
              style={{
                marginRight: "10px",
                width: "30px",
              }}
              alt="EPIC"
            />
          );
          break;
        case "Cerner":
          EHRIcon = (
            <img
              src={cernerSelecr}
              style={{
                marginRight: "10px",
                width: "30px",
              }}
              alt="Cerner"
            />
          );
          break;
        case "Athena Health":
          EHRIcon = (
            <img
              src={aaathenaSelect}
              style={{
                marginRight: "10px",
                width: "30px",
              }}
              alt="Athena"
            />
          );
          break;
        default:
          EHRIcon = (
            <img
              src={others}
              style={{
                marginRight: "10px",
                width: "30px",
              }}
              alt="Others"
            />
          );
      }
      return {
        label: getPatientName(patient.name),
        value: patient.id,
        ehr: ehrtype,
        icon: EHRIcon,
      };
    });
    setPatientName(patientData[0].label);
    setSelectedPatient(patientData[0].value);
    setIsLoading(false);
    setPatientList(patientData);
  };

  const SelectItem = forwardRef<HTMLDivElement, ItemProps>(
    ({ label, value, ehr, icon, ...others }: ItemProps, ref) => (
      <div ref={ref} {...others}>
        <Group
          noWrap
          sx={{
            justifyContent: "space-between",
            height: "30px",
            width: "100%",
          }}
        >
          <div>
            <Text>{label}</Text>
          </div>
          <div>{icon}</div>
        </Group>
      </div>
    )
  );

  const generateSymptoms = () => {
    setAiResponse("Generating...");

    getSymptoms(medplum, selectedPatient, selectedSymptom).then((res) => {
      setInput(res?.input?.[0]);
      const diseasesResponse = summarizeDisease(res, patientName);
      setAiResponse(diseasesResponse);

      setSummaryTags({
        diseases: ["fever"] ?? [],
        drugs: ["Paracetamol"] ?? [],
        observations: ["No significant findings"] ?? [],
      });
    });
  };
  return (
    <>
      <Paper className={classes.default}>
        <Box>
          <Box sx={{ paddingBottom: "24px", marginTop: "16px" }}>
            <Title className={classes.heading}>AI Recipes</Title>
          </Box>
          <Box>
            <Box sx={{ marginBottom: "100px" }}>
              <Box sx={{ marginBottom: "24px" }}>
                <Box>
                  <Text className={classes.tite}>Try AI Recipes</Text>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "16px",
                      marginBottom: "16px",
                    }}
                  >
                    {recipeList.map((recipe, i) => (
                      <Box
                        className={classes.ai}
                        sx={{
                          border:
                            showAi == i + 1
                              ? "1px solid " + COLORS.borderBlue
                              : "1px solid " + COLORS.borderGray,
                        }}
                        onClick={() => showaiSummary(i + 1)}
                      >
                        <img
                          src={recipe.icon}
                          className={
                            classes.imageStyle +
                            " " +
                            (showAi == i + 1 ? classes["filter-blue"] : "")
                          }
                        />
                        <Text
                          color={
                            showAi == i + 1
                              ? COLORS.borderBlue
                              : COLORS.textBlack
                          }
                        >
                          {recipe.label}
                        </Text>
                      </Box>
                    ))}
                  </Box>
                </Box>

                <Text className={classes.select}>
                  Select Patient <span style={{ color: "red" }}>*</span>
                </Text>
                <Box
                  sx={{
                    height: "50px",
                    borderRadius: "5px",
                  }}
                >
                  {" "}
                  <Select
                    disabled={aiResponse === "Generating..."}
                    placeholder={isLoading ? "Loading..." : "Search Patient"}
                    required={true}
                    data={patientList}
                    rightSection={isLoading ? <Loader size={"sm"} /> : ""}
                    mt="sm"
                    size="lg"
                    radius="md"
                    value={selectedPatient}
                    onChange={(val) => {
                      setSelectedPatient(val);
                    }}
                    clearable={true}
                    sx={{
                      ".mantine-Select-itemsWrapper": {
                        paddingRight: "10px",
                      },
                    }}
                    searchable
                    itemComponent={SelectItem}
                  />
                </Box>
                <Box w={"100%"} mt={16}>
                  {aiResponse === "Generating..." ? (
                    <></>
                  ) : (
                    <Accordion
                      // variant="separated"
                      // defaultValue="customization"
                      chevron={<IconPlus size="1rem" />}
                      styles={{
                        chevron: {
                          "&[data-rotate]": {
                            transform: "rotate(45deg)",
                          },
                        },
                      }}
                    >
                      {" "}
                      <Accordion.Item value="customization">
                        <Accordion.Control>
                          <Text
                            sx={{
                              fontWeight: 600,
                              fontSize: "15px",
                              lineHeight: "30px",
                              color: "#262930",
                            }}
                          >
                            {" "}
                            Patient Data
                          </Text>
                        </Accordion.Control>
                        <Accordion.Panel
                          sx={{ marginLeft: "-12px", marginRight: "-12px" }}
                        >
                          <Card showAi={showAi} data={input || []} />
                        </Accordion.Panel>
                      </Accordion.Item>
                    </Accordion>
                  )}
                </Box>
                {showAi === 5 && (
                  <Box>
                    <Box
                      mt="md"
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box w={"88%"}>
                        <Text className={classes.select}>
                          Patient Symptom{" "}
                          <span style={{ color: "red" }}>*</span>
                        </Text>
                        <TextInput
                          size="lg"
                          radius="md"
                          mt="sm"
                          placeholder="Enter a symptom"
                          value={selectedSymptom} 
                          onChange={(event) =>
                            setSelectedSymptoms(event.currentTarget.value)
                          }
                        />
                      </Box>

                      <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                        <Button
                          variant="outline"
                          size="lg"
                          radius={"md"}
                          disabled={
                            !selectedSymptom || aiResponse === "Generating..."
                          }
                          onClick={generateSymptoms}
                        >
                          {" "}
                          <img
                            src={aiStartsSvg}
                            style={{ marginRight: "8px" }}
                          />{" "}
                          Generate
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                )}
                {showSumm && (
                  <Box>
                    <Box className={classes.boxFirst} mt={16}>
                      <Summary
                        text={aiResponse}
                        cardiovascular={cardioPrediction}
                        diseases={summaryTags?.diseases}
                        drugs={summaryTags?.drugs}
                        observations={summaryTags?.observations}
                        cardioRed={cardioRed}
                      />
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      </Paper>
    </>
  );
};
